import { defineStore } from 'pinia'
import _ from 'lodash'
import { onValue } from "firebase/database";
import { useTableStore } from './table';

export const useSettingStore = defineStore({
  id: 'setting',
  state: () => {
    return {
      settingsList : [],
    }
  },  
  getters: {
    getValueBysettingId(state) {
      return (settingId: string, defaultValue: any) => {
        let data = state.settingsList?.find((x: any) => x.settingId === settingId);
        if (data) {
          return data.value;
        } else {
          return defaultValue;
        }
      };
    },
    storeName(state) {

      let name = _.find(state.settingsList, { settingId : 'name' });
      if (name) {
        return name.value
      }
      return ""
    },
    findMenuSetting(state) {
      return (menuId) => {
        return _.find(state.settingsList, { settingId : menuId });
      }
    }
  },
  actions: {
    init(){
      this.watchSettingRealtime()
    },

    watchSettingRealtime(){
      const tableStore = useTableStore()
      const { settingsRef } = useFirebaseXtable();
      const ref = settingsRef()
      onValue(ref, (snapshot) => {
        const setting = snapshot.val()
        this.settingsList = setting  
        
        let zones = findValueByIdInList(setting, "tables");
        tableStore.zoneList = zones
        tableStore.zoneListComputed = generateTablesListFromZoneList(zones)

        tableStore.tables = setting.tables;

      });
    }
  },
})

function findValueByIdInList(list, settingId) {

  const result = _.find(list, { settingId });
  console.log(result);

  return result?.value;
}

function generateTablesListFromZoneList(zones) {
  let list = [];
  _.forEach(zones, (z) => {
      let zone = {
          name: z.name,
          tables: [],
      };

      _.times(z.value, (i) => {
          zone.tables.push(zone.name + "" + (i + 1));
      });
      list.push(zone);
  });

  return list;
}